/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import PropTypes from 'prop-types'; // eslint-disable-line no-unused-vars
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import { FormHelpBlock, LabelWithRequired, joinDataTestId } from '@motili/ui';
import { getValidationState } from 'common/utils/validation-utils';

FormTextArea.propTypes = {
    label: PropTypes.string,
    labelStyle: PropTypes.object,
    style: PropTypes.object,
    inputStyle: PropTypes.object,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    optional: PropTypes.bool,
    validation: PropTypes.shape({
        state: PropTypes.oneOf(['error', 'warning', 'success']),
        message: PropTypes.string,
    }),
    controlId: PropTypes.string.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    maxLength: PropTypes.string,
    dataTestId: PropTypes.string,
};

FormTextArea.defaultProps = {
    style: {},
    inputStyle: {},
    controlId: 'form-textarea',
    validation: {},
    maxLength: '',
};

export default function FormTextArea(props) {
    const { isInvalid, isValid, isWarning } = getValidationState(
        props.validation
    );

    return (
        <Form.Group controlId={props.controlId} style={props.style}>
            {props.label && (
                <LabelWithRequired required={props.required} dataTestId={props.dataTestId}>
                    {props.label}
                </LabelWithRequired>
            )}
            <FormControl
                style={props.inputStyle}
                as='textarea'
                value={props.value}
                disabled={props.disabled}
                placeholder={props.placeholder}
                onChange={props.onChange}
                onBlur={props.onBlur}
                maxLength={props.maxLength}
                isValid={isValid}
                isInvalid={isInvalid}
                data-test-id={joinDataTestId([props.dataTestId, 'input'])}
            />
            {isInvalid && (
                <FormHelpBlock>
                    {props.validation.message || 'Invalid'}
                </FormHelpBlock>
            )}
            {isWarning && (
                <FormHelpBlock>
                    {props.validation.message || 'Warning'}
                </FormHelpBlock>
            )}
        </Form.Group>
    );
}
